import { Page } from "lola-framework-ui-test";
import { Route, Routes } from "react-router-dom";
import { useReadTheme } from "./hooks/useReadTheme";
import { useSessionExpiredHandler } from "./hooks/useSessionExpiredHandler";
import { useLanguageSync } from "./hooks/useLanguageSync";
import { useStore } from "./store/globalState";
import { routesList } from "./utils";

const App = () => {
  const { theme } = useStore();
  const { isLoadingTheme, reedTheme } = useReadTheme();

  // Handle session expired events globally
  useSessionExpiredHandler();

  // Re-sync i18n language from persisted session after page refresh
  useLanguageSync();

  return (
    <Page
      font={{
        cdn: reedTheme.font.fontcdn,
        name: reedTheme.font.fontfamily,
      }}
    >
      <section>
        {isLoadingTheme && <p>Loading theme...</p>}
        {!theme && <p>Theme not loaded</p>}
        <Routes>
          {routesList.map(({ path, Component }) => (
            <Route key={path} path={path} Component={Component} />
          ))}
        </Routes>
      </section>
    </Page>
  );
};

export default App;
